<template>
    <div class="page-warpper indexRule">
        <div class="part-panel" data-index='pro'>
            <!-- <h1 class="part-title"></h1> -->
            <div class="part-body self-bg">
                <img src="../assets/images/index/cnt-pro.png" alt="">
            </div>
        </div>
        <div class="part-panel part-special" data-index='prize'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg" >
                <img src="../assets/images/index/cnt-prize.png" alt="">
            </div>
        </div>
         <div class="part-panel part-special" data-index='judge'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg part-txt">
                <img src="../assets/images/index/cnt-judge.png" alt="">
            </div>
        </div>
        <div class="part-panel part-special" data-index='rule'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg part-txt">
                <ul  class='part-txt'>
                    <li>评判标准将充分考虑整体效果，包括但不限于以下评审因素，决定最终结果。 </li>
                    <li>1. 作曲编曲（限原创作品）。</li>
                    <li>2. 作词（主题思想、行文、押韵、意境等）。</li>
                    <li>3. 演唱（音准、气息、表现力等）。</li>
                    <li>4. 后期效果。</li>
                    <li>5. 观众支持（玩家投票、点赞、外链分享数、评论等），成功参赛即可接受观众投票，投票仅作为热门排序，不影响最终评选结果。票选时段与提交参赛作品时段一致。</li>
                </ul>
            </div>
        </div>

        <div class="part-panel part-special" data-index='notice'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <ul  class='part-txt'>
                    <li>1. 作品不得违反国家法律法规，不得过度宣扬色情、暴力、血腥等不良内容。 </li>
                    <li>2. 请参赛者保证自身对于上传的内容，拥有相应的合法权利并有权用于参与本活动，参赛作品不得侵犯第三方的知识产权和专利，且腾讯公司有权根据活动需求使用相关内容。 若其版权归属多人的情况下，参赛选手请保证作品已获得其他版权所有者的授权。如有违反则取消参赛资格，且投稿人自行承担法律责任及此行为造成的一切后果及损失。</li>
                    <li>3. 作品所有版权归作者与腾讯动漫、腾讯音乐集团（TME）共同所有，一经投稿则视为允许主办方在活动相关专题、官网、新闻、微博、微信等推广中署名宣传中进行使用。</li>
                    <li>4. 获奖作品一经投稿及认可获奖结果则视为允许腾讯动漫在全世界范围内通过如下方式使用：有权使用授权作品、授权素材（包括但不限于授权人个人信息等素材）的复制权、表演权、广播权、信息网络传播权、表演者权、录音录像制作者权，并有权转授权第三方使用授权作品。</li>
                    <li>5. 未经主办方同意，参赛者不得将同一参赛作品自行用于商业用途或授予任何第三方使用，否则取消获奖资格。</li>
                    <li>6. 秉承公平公正的原则，本次大赛禁止刷票，发现者直接取消参赛资格。</li>
                    <li>7. 本活动最终解释权归5sing & 腾讯动漫所有。</li>
                </ul>
            </div>
        </div>
        <div class="part-panel part-special">
            <div  class="part-warpper" data-index='sponsor'>
                <div data-index='1'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item md" href=" http://ac.qq.com/"   target="_blank"></a>
                        <a class="part-item mg" href="javascript:void(0);"></a>
                        <a class="part-item sing" href="http://5sing.kugou.com/index.html"   target="_blank"></a>
                        <a class="part-item kugou" href="http://www.kugou.com/"   target="_blank"></a>
                    </div>
                </div>
               
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'indexRule',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../assets/sass/cmn.scss";
.txt-head{
    font-size: 24px;
    font-weight: 600;
    color: #7be5ff;
    text-align: center;
}
.txt-yellow{
    color: #fffc00;
}
.part-panel[data-index="pro"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-pro.png'));
    }
}
.part-panel[data-index="prize"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-prize.png'));
    }
    .part-body{
        padding-top: 0;
        text-align: center;
    }
}
.part-panel[data-index="judge"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-judge.png'));
    }
    .part-body{
        text-align: center;
    }
}
.part-panel[data-index="rule"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-rule.png'));
    }

}
.part-panel[data-index="notice"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-notice.png'));
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index-rule.vue